'use strict';

var _ = require('lodash');
var ColumnNameTransformationService = function ColumnNameTransformationService() {
  function flattenColumnNames(exportData, gridSettings, type) {
    var xlsColumnHeader = {
      prefix: '<Cell ss:StyleID="xls-style-1"><Data ss:Type="String">',
      suffix: '</Data></Cell>'
    };
    var htmlColumnHeader = {
      prefix: '>',
      suffix: '</th>'
    };
    var selectedHeader = type === 'html' ? htmlColumnHeader : xlsColumnHeader;
    _.chain(gridSettings.columns).filter(function (column) {
      return column.hidden === false && column.hasOwnProperty('columngroup');
    }).forEach(function (column) {
      var columnGroupMatch = _.find(gridSettings.columngroups, function (columngroup) {
        return columngroup.id === column.columngroup;
      });
      if (columnGroupMatch) {
        var oldValue = selectedHeader.prefix + column.text + selectedHeader.suffix;
        var newValue = selectedHeader.prefix + column.text + ' ' + columnGroupMatch.text + selectedHeader.suffix;
        exportData = exportData.replace(oldValue, newValue);
      }
    }).value();
    return exportData;
  }
  function changeColumns(gridSettings, columnsToChange, hidden) {
    var method = hidden ? 'hidecolumn' : 'showcolumn';
    _.forEach(gridSettings.columns, function (column) {
      if (columnsToChange.indexOf(column.datafield) !== -1) {
        column.hidden = hidden;
        //NOTE: This Make Sure Hide Columns on jqWidget Side
        gridSettings.jqxGrid(method, column.datafield);
      }
    });
    gridSettings.jqxGrid('updatebounddata', 'data');
  }
  function hideColumns(gridSettings, columnsToChange) {
    changeColumns(gridSettings, columnsToChange, true);
  }
  function unhideColumns(gridSettings, columnsToChange) {
    changeColumns(gridSettings, columnsToChange, false);
  }
  function getColumnsToHide(gridSettings) {
    var columnsToChange = ['bookingsIntakeHtml', 'segClassBookingsIntakeHtml', 'slackDistributionMethodEMSRParams', 'overBookingParams', 'bidPriceCurveParams', 'businessRulesProperties', 'bidPriceCurveParams', 'foMinStayGroupingProperties', 'foMaxStayGroupingProperties', 'taxOverridePropertiesList', 'advancePurchaseGroupingProperties', 'foRBDLevelFareThresholdPropertiesList', 'cabinClassConfigPropertiesList', 'fareClassMappingProperties', 'foAnalystPosMappingProperties', 'inputDataComparisonChecksProperties', 'tacticalFbcPatterns', 'foTacticalFareIndexProperties', 'proactiveBlackoutPropertiesList', 'fareBrandAssignmentPropertiesList', 'fareBrands', 'surchargeManagementProperties'];
    var allColumns = _.chain(gridSettings.columns).filter(function (column) {
      return !column.hidden;
    }).map('datafield').value();
    return _.intersection(columnsToChange, allColumns);
  }
  return {
    flattenColumnNames: flattenColumnNames,
    hideColumns: hideColumns,
    unhideColumns: unhideColumns,
    getColumnsToHide: getColumnsToHide
  };
};
ColumnNameTransformationService.$inject = [];
module.exports = ColumnNameTransformationService;